import { SgvId, SgvJson } from '@eceos/arch';
import { IbsCbs } from '../../../nfes/tax/ibscbs/ibs-cbs';

export class IbsCbsConfig {
  constructor(
    readonly id: string = SgvId.gen(),
    public cst: string = null,
    public cClassTrib: string = null,
    public pIbsUf: number = null,
    public pIbsMun: number = null,
    public pCbs: number = null
  ) {}

  toIbsCbs(): IbsCbs {
    return new IbsCbs(undefined, this.cst, this.cClassTrib, this.pIbsUf, this.pIbsMun, this.pCbs);
  }

  toJson(): any {
    return SgvJson.to.simple(this);
  }

  static fromJson(json: any): IbsCbsConfig {
    return json ? SgvJson.from.simple(json, IbsCbsConfig) : null;
  }
}
